// applicationFormConstant.ts
import type { AuthDropdownOption } from "@/pages/authenticationV2/signUp/components/AuthDropdown";
import type { AuthOptionItem } from "@/pages/authenticationV2/signUp/components/AuthOptionGroup";

// skin tone
import FairSkinTone from "@/assets/icons/authentication/skinTone/FairSkin.svg";
import BrownSkinTone from "@/assets/icons/authentication/skinTone/BrownSkin.svg";
import DarkSkinTone from "@/assets/icons/authentication/skinTone/DarkSkin.svg";
import NoPrefSkinTone from "@/assets/icons/authentication/skinTone/NoPref.svg";

// body type
import AverageBodyType from "@/assets/icons/authentication/bodyType/Average.svg";
import AthleticBodyType from "@/assets/icons/authentication/bodyType/Athletic.svg";
import PlusBodyType from "@/assets/icons/authentication/bodyType/Plus.svg";
import SlimBodyType from "@/assets/icons/authentication/bodyType/Slim.svg";
import NoPrefBodyType from "@/assets/icons/authentication/bodyType/NoPref.svg";

/** STEP 2: Age dropdown options */
export const AGE_GROUP_OPTIONS: AuthDropdownOption[] = [
  { key: "Teens", label: "Teens (13-18 years)" },
  { key: "YoungAdults", label: "Young Adults (19-29 years)" },
  { key: "Adults", label: "Adults (30-45 years)" },
  { key: "MiddleAged", label: "Middle-Aged (46-60 years)" },
];

/** STEP 2: Gender dropdown options */
export const GENDER_OPTIONS: AuthDropdownOption[] = [
  { key: "Male", label: "Male" },
  { key: "Female", label: "Female" },
  { key: "Others", label: "Others" },
];

/** STEP 2: Body type options (OptionGroup) */
export const BODY_TYPE_OPTIONS: AuthOptionItem[] = [
  {
    key: "Average",
    label: "Average",
    icon: <AverageBodyType />,
  },
  {
    key: "Slim",
    label: "Slim",
    icon: <SlimBodyType />,
  },
  {
    key: "Athletic",
    label: "Athletic",
    icon: <AthleticBodyType />,
  },
  {
    key: "Plus",
    label: "Plus Size",
    icon: <PlusBodyType />,
  },

  {
    key: "no-pref",
    label: "No Preference",
    icon: <NoPrefBodyType />,
  },
];
export const WHO_CAN_APPEAR_IN: AuthOptionItem[] = [
  {
    key: "Solo_only",
    label: "Solo only",
  },
  {
    key: "Friends_peers",
    label: "Friends / peers",
  },
  {
    key: "Family_members",
    label: "Family members",
  },

  {
    key: "not-available",
    label: "Not available",
  },
];

/** STEP 2: Skin tone options (OptionGroup) */
export const SKIN_TONE_OPTIONS: AuthOptionItem[] = [
  { key: "fair", label: "Fair-Skinned", icon: <FairSkinTone /> },
  { key: "brown", label: "Brown-Skinned", icon: <BrownSkinTone /> },
  { key: "dark", label: "Dark-Skinned", icon: <DarkSkinTone /> },
  { key: "no-preference", label: "No preference", icon: <NoPrefSkinTone /> },
];
